export default __webpack_public_path__ + "static/media/nonActiveTick.e505f7b5.svg";